<template>
  <div>
    <px-lista-selecao-requisicao-produtos v-model="produtos" />
  </div>
</template>

<script>
import ListaSelecaoRequisicaoProdutos
  from '@/modules/requisicao/geracao/lista-selecao-requisicao-produtos/ListaSelecaoRequisicaoProdutos.vue';

export default {
  data() {
    return {
      produtos: [],
    };
  },
  components: {
    pxListaSelecaoRequisicaoProdutos: ListaSelecaoRequisicaoProdutos,
  },
};
</script>
